// import lib
import validHelper from '../lib/validHelper';
import isEmpty, { isFileEmpty } from '../lib/isEmpty';

export const loginValid = (reqBody) => {
    let validDoc = {
        email: { type: 'string', required: true, regex: 'email' },
        password: { type: 'string', required: true, regex: 'password' },
        tfaStatus: { type: 'boolean', required: true },
        code: { type: 'number', required: reqBody.tfaStatus, length: 6 }
    }

    return validHelper(validDoc, reqBody)
}

export const addSubAdmin = (reqBody) => {
    let validDoc = {
        email: { type: 'string', required: true, regex: 'email' },
        password: { type: 'string', required: true, regex: 'password' },
        name: { type: 'string', required: true },
        restriction: { type: 'array', required: true },
    }

    return validHelper(validDoc, reqBody)
}

export const editSubAdmin = (reqBody) => {
    let validDoc = {
        _id: { type: 'string', required: true },
        email: { type: 'string', required: true, regex: 'email' },
        name: { type: 'string', required: true },
        restriction: { type: 'array', required: true },
        status: { type: 'string', required: true, enum: ['verified', 'unverified'] }
    }

    return validHelper(validDoc, reqBody)
}

export const tfaValid = (reqBody) => {
    let validDoc = {
        code: { type: 'number', required: true, length: 6 }
    }

    return validHelper(validDoc, reqBody)
}

export const profileValid = (reqBody) => {
    let validDoc = {
        name: { type: 'string', required: true },
        email: { type: 'string', required: true, regex: 'email' }
    }
    if (!isFileEmpty(reqBody.profile) && reqBody.hasOwnProperty('profile')) {
        validDoc.profile = { type: 'file', required: !isFileEmpty(reqBody?.profile), acceptExt: ['jpg', 'jpeg', 'png', 'webp'] }
    }

    return validHelper(validDoc, reqBody)
}